import { render, staticRenderFns } from "./BlogCategoryEdit.vue?vue&type=template&id=1f76819e&scoped=true&"
import script from "./BlogCategoryEdit.vue?vue&type=script&lang=js&"
export * from "./BlogCategoryEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f76819e",
  null
  
)

export default component.exports